import { HttpHeaders } from "@angular/common/http";

export class ApiResponse<DataType> {
    public status: number;
    public data: DataType;
    public messages: string[];
    public headers: HttpHeaders;


    constructor(status: number, data: DataType, messages: string[] = [], headers?: HttpHeaders) {
        this.status = status;
        this.data = data;
        this.messages = messages;
        this.headers = headers;
    } 

    appendMessage(message: string): void {
        this.messages.push(message);
    }

    setData(data: DataType) {
        this.data = data;
    }

    setMessages(messages: string[]) {
        this.messages = messages;
    }

    setStatus(status: number) {
        this.status = status;
    }

    extendDataWithArray<ItemType>(items: ItemType[]) {
        if (Array.isArray(this.data)) {
            this.data.push(...items);
        }
    }
}
